import useRequest, { RequestResult, Fetch } from "./useRequest";

import { DeviceListResult, HiveListParams } from "../types";

export default function useDeviceList(
  params?: HiveListParams,
): [RequestResult<DeviceListResult>, Fetch] {
  return useRequest<DeviceListResult, any>("/device/list/", { ...params, expanded: 1 });
}
